import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useAppStore } from '@store'
import { LinkedItemSon, AnyID } from '@types'
import clsx from 'clsx'
import { useState, useEffect } from 'react'

type Props = {
  id: string
}

export function LinkedSonZones({ id }: Props) {
  const actualID = id.split('!')[1]
  const item = useAppStore((s) => s.items.get(actualID as AnyID)) as LinkedItemSon

  const {
    setHighlighted,
    setIsModel,
    highlighted,
    setRightInfo,
    setCenterInfo,
    setIamUp,
    setModelo,
    setAcabado,
    centerInfo,
    rightInfo,
    setSelectedTexture,
    handleLinkedEncimeraZone,
    actions: { handleGroupClick },
  } = useLinkedContext()

  const [pendingAutoClick, setPendingAutoClick] = useState<string | null>(null)

  useEffect(() => {
    if (pendingAutoClick && centerInfo && centerInfo.length > 0) {
      let targetItem = centerInfo.find((item: any) => item.acabado === pendingAutoClick)

      if (!targetItem) {
        if (pendingAutoClick.includes('Porcelanicas 20')) {
          targetItem = centerInfo.find((item: any) => item.acabado === 'Porcelanicas 20')
        } else if (pendingAutoClick.includes('Porcelanicas 12')) {
          targetItem = centerInfo.find((item: any) => item.acabado === 'Porcelanicas 12')
        } else if (pendingAutoClick.includes('Postformadas')) {
          targetItem = centerInfo.find((item: any) => item.acabado === 'Postformadas')
        } else if (pendingAutoClick.includes('Compacto')) {
          targetItem = centerInfo.find((item: any) => item.acabado === 'Compacto')
        } else {
          if (item && item.textures) {
            const childTextureName = item.textures[0]?.name
            if (childTextureName) {
              if (childTextureName.startsWith('EML12') || childTextureName.includes('12')) {
                targetItem = centerInfo.find((item: any) => item.acabado === 'Porcelanicas 12')
              } else if (childTextureName.startsWith('EML20') || childTextureName.includes('20')) {
                targetItem = centerInfo.find((item: any) => item.acabado === 'Porcelanicas 20')
              } else {
                targetItem = centerInfo[0]
              }
            } else {
              targetItem = centerInfo[0]
            }
          } else {
            targetItem = centerInfo[0]
          }
        }
      }

      if (targetItem) {
        handleGroupClick(targetItem.idAcabadoUnidadModeloAcabado, targetItem.acabado)
        setPendingAutoClick(null)
      }
    }
  }, [centerInfo, pendingAutoClick, handleGroupClick])

  useEffect(() => {
    if (
      pendingAutoClick &&
      rightInfo &&
      rightInfo.textures &&
      rightInfo.textures.length > 0 &&
      item &&
      item.textures
    ) {
      const childTextureName = item.textures[0]?.name
      if (childTextureName) {
        const targetTexture = rightInfo.textures.find((tex: any) => tex.nombre === childTextureName)
        if (targetTexture) {
          setSelectedTexture(targetTexture)
          setPendingAutoClick(null)
        }
      }
    }
  }, [rightInfo, pendingAutoClick, item?.textures])

  if (!item) {
    return null
  }

  // const getParentIdUnidades = () => {
  //   const parentID = item?.firstParentID
  //   if (!parentID) return null
  //   const parentItem = useAppStore.getState().items.get(parentID)
  //   return parentItem?.idUnidades
  // }

  async function handleParentClick() {
    setHighlighted(actualID)
    setIsModel(false)
    setIamUp(true)
    setModelo(item.description)

    if (item.description === 'Encimera') {
      const linkedTextureID = item.textures?.[0]?.linkedTextureID
      const childAcabado = item.textures?.[0]?.acabado

      if (linkedTextureID) {
        const ok = await handleLinkedEncimeraZone(linkedTextureID)
        if (ok) {
          setAcabado(childAcabado || '')
          setPendingAutoClick(childAcabado || '')
          setIamUp(false)
          // resetCopyAndPaste()
          return
        }
      }
    }

    setRightInfo({
      name: item.description || '',
      textures: item.textures || [],
    })
    setCenterInfo([])
    // resetCopyAndPaste()
    // Si realmente quieres refrescar todos los hijos (por ejemplo, al cambiar el modelo del padre),
    // Así se hacía antes de los nuevos cambios de estructura hechos para TPC, ver si cuando llegue posición esto se puede reaprovechar
    // ó con otro cliente con estructura de datos distinta
    // Y llamar a fetchLinkedChildrenInfo.
    // try {
    //   const idUnidades = getParentIdUnidades()
    //   if (!idUnidades) {
    //     return
    //   }
    //   const data = await fetchLinkedChildrenInfo(idUnidades)
    //   if (!data || !data['0']) {
    //     return
    //   }
    //   const parentKeys = Object.keys(data['0'])
    //   const nodeOption = item.option
    //   const selectedKey = parentKeys.find((key) =>
    //     data['0'][key].some((texture) => texture.nodo === nodeOption),
    //   )
    //   if (!selectedKey) {
    //     return
    //   }
    //   const rawTextures = data['0'][selectedKey].filter((texture) => texture.nodo === nodeOption)
    //   const textures = rawTextures.map((texture) => ({
    //     ...texture,
    //     id: texture.idElementosEnlazados,
    //     name: texture.descripcion,
    //     url:
    //       texture.referenciaJpgpng ??
    //       'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSGLd-lxkvRNRTGHR3wz9RUl20mUDfxOZgEIw&s',
    //   }))
    //   setRightInfo({
    //     name: selectedKey,
    //     textures: textures,
    //   })
    //   setCenterInfo([])
    //   resetCopyAndPaste()
    // } catch (error) {
    //   console.error('Error al obtener los datos:', error)
    // }
  }

  return (
    <div className='scroll-y-auto flex flex-col'>
      <div
        className={clsx(
          ' cursor-pointer text-[16px] font-bold',
          highlighted === actualID && 'bg-C/Color2',
        )}
        style={{ paddingLeft: `${(item.depth - 1) * 33}px` }}
        onClick={handleParentClick}
      >
        <div className='ml-6 mt-2'>
          {item.description === 'TPCGrifo' || item.description === 'TPC Grifo'
            ? 'Grifo'
            : item.description}
        </div>
      </div>
    </div>
  )
}
